import React from 'react';
import { Star, ShieldCheck, Award, CheckCircle2 } from 'lucide-react';

const TrustSection: React.FC = () => {
  const reviews = [
    "Best cleaning service in Jersey City.",
    "Always reliable and incredibly thorough.",
    "Professional and easy to book."
  ];

  return (
    <section className="py-12 bg-white border-b border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Badges */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 w-full lg:w-auto">
            <div className="flex flex-col items-center text-center space-y-2">
              <div className="w-16 h-16 bg-brand-blue/5 rounded-2xl flex items-center justify-center">
                <Star className="w-8 h-8 text-brand-blue fill-current" />
              </div>
              <span className="text-xs font-bold text-brand-navy uppercase tracking-tighter">5.0 Star Rating</span>
            </div>
            <div className="flex flex-col items-center text-center space-y-2">
              <div className="w-16 h-16 bg-brand-blue/5 rounded-2xl flex items-center justify-center">
                <ShieldCheck className="w-8 h-8 text-brand-blue" />
              </div>
              <span className="text-xs font-bold text-brand-navy uppercase tracking-tighter">Google Top Rated</span>
            </div>
            <div className="flex flex-col items-center text-center space-y-2">
              <div className="w-16 h-16 bg-brand-blue/5 rounded-2xl flex items-center justify-center">
                <Award className="w-8 h-8 text-brand-blue" />
              </div>
              <span className="text-xs font-bold text-brand-navy uppercase tracking-tighter">A+ BBB Rating</span>
            </div>
            <div className="flex flex-col items-center text-center space-y-2">
              <div className="w-16 h-16 bg-brand-blue/5 rounded-2xl flex items-center justify-center">
                <CheckCircle2 className="w-8 h-8 text-brand-blue" />
              </div>
              <span className="text-xs font-bold text-brand-navy uppercase tracking-tighter">TrustPilot Verified</span>
            </div>
          </div>

          {/* Review Snippets */}
          <div className="flex flex-wrap justify-center lg:justify-end gap-4">
            {reviews.map((review, index) => (
              <div 
                key={index}
                className="bg-brand-gray-50 px-6 py-3 rounded-full border border-brand-gray-200 flex items-center space-x-3 shadow-sm"
              >
                <div className="flex space-x-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-3 h-3 text-yellow-400 fill-current" />
                  ))}
                </div>
                <p className="text-sm font-medium text-brand-navy italic">"{review}"</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
